<template>
    <b-container class="recipe-list-section">
        <mobile-gutter>
            <b-row v-if="recipes.length">
                <b-col
                    xl="10"
                    offset-xl="1"
                >
                    <div class="list">
                        <div
                            v-for="item in recipes"
                            :key="item.name"
                            class="list-item"
                        >
                            <item-card v-bind="item" />
                        </div>
                    </div>
                </b-col>
            </b-row>

            <div v-else class="no-recipes">
                <h2>{{ $snippet('no_recipes_found_title', 'Sorry, there were no recipes found') }}</h2>

                <p>{{ $snippet('no_recipes_found_subtitle', 'Please adjust your filters.') }}</p>
            </div>
        </mobile-gutter>
    </b-container>
</template>

<script>
    import ItemCard from '../../molecules/ItemCard/ItemCard';

    export default {
        name: 'recipe-list-section',

        components: { ItemCard },

        props: {
            recipes: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .list {
        @include media-breakpoint-up(sm) {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            grid-column-gap: 20px;
        }
        @include media-breakpoint-up(lg) {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            grid-column-gap: 40px;
        }
        @include media-breakpoint-up(xl) {
            grid-column-gap: 80px;
        }
    }

    .list-item {
        margin-bottom: 24px;
        @include media-breakpoint-up(lg) {
            margin-bottom: 34px;
        }
    }

    .item-card {
        max-width: 327px;
        margin-left: auto;
        margin-right: auto;
        @include media-breakpoint-up(lg) {
            max-width: unset;
        }
    }

    .no-recipes {
        padding: 100px 0;
    }
</style>
